/**
 * The Financy palette and type, shared by the MUI theme, the charts and any
 * component that needs a raw value. Petrol is the one accent; amber is kept
 * for "over" and "due soon", never for decoration.
 */
export const tokens = {
  accent: '#0F766E',
  accentDark: '#0B6159',
  accentDeep: '#0C5953',
  accentSoft: '#E9F3F2',
  accentSoft2: '#D9E9E8',
  /** the hatch next to the accent: money promised to open bills */
  accentHatch: '#9CCBC6',
  bg: '#F4F6F5',
  surface: '#FFFFFF',
  ink: '#0F1B1F',
  ink2: '#3E4D53',
  ink3: '#5A6A70',
  line: '#E1E7E5',
  warn: '#B45309',
  warnSoft: '#FBF0E6',
  danger: '#B42318',
  display: "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
  body: "'DM Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
  radius: { card: 20, control: 12, pill: 999 },
  shadow: {
    soft: '0 1px 2px rgba(15,27,31,.06), 0 12px 32px -16px rgba(15,27,31,.22)',
    menu: '0 2px 6px rgba(15,27,31,.08), 0 18px 40px -12px rgba(15,27,31,.28)',
  },
} as const;

/**
 * One color per person in a group, each with its light tint, picked by the
 * member's position so the same person keeps the same color everywhere.
 */
export const personColors = [
  { color: '#B45309', tint: '#F3E4D8' },
  { color: '#1D4ED8', tint: '#DBE3F9' },
  { color: '#7E22CE', tint: '#EADCF7' },
  { color: '#0F766E', tint: '#D9E9E8' },
  { color: '#BE185D', tint: '#F7DDE8' },
  { color: '#4D7C0F', tint: '#E3EED4' },
] as const;

export const personColor = (index: number) => personColors[((index % personColors.length) + personColors.length) % personColors.length];
